module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_vestfold_telemark_neg.57e0e2c5.pdf";